import React from "react";
import { Link } from "react-router-dom";
import "../css/policies.scss";

export const POLICY_UPDATED = "October 16, 2026";
export const CONTACT_ADDRESS = "276 Bedok Rd, Singapore 469435";

export function ContactEmail({ subject }) {
  const href = subject
    ? `mailto:kit@sacuddin.shop?subject=${encodeURIComponent(subject)}`
    : "mailto:kit@sacuddin.shop";

  return <a href={href}>kit@sacuddin.shop</a>;
}

export function PolicyPage({ title, intro, children, updated = POLICY_UPDATED }) {
  return (
    <main className="policy-page">
      <div className="wrapper--narrow section-padding">
        <article className="policy-article">
          <header className="policy-header">
            <p className="standard__kicker">Sacuddin policies</p>
            <h1>{title}</h1>
            <p className="policy-updated">Last updated: {updated}</p>
            {intro && <p className="policy-intro">{intro}</p>}
          </header>

          <div className="rte policy-content">{children}</div>

          <aside className="policy-contact" aria-label="Policy contact information">
            <h2>Questions?</h2>
            <p>
              Contact Sacuddin at <ContactEmail subject={`${title} question`} />.
              Please include your order number when your message concerns a purchase.
            </p>
            <address>{CONTACT_ADDRESS}</address>
          </aside>

          <p className="policy-back-link">
            <Link to="/policies">View all policies</Link>
          </p>
        </article>
      </div>
    </main>
  );
}

export function PolicySection({ title, children }) {
  return (
    <section className="policy-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}
